import { useEffect, useState } from "react";
import { AddButtonCell, EditDeleteCell, InputCell, NewRowTemplate, Table } from "../../../components/BasicComponents";
import { useApp } from "../../../hooks/AppProvider";

function BehaviorTermsTable({ terms, currentTermId, onUpdate, onTerminate, onDelete, onStart }) {

    return (
        <Table headers={["Nom de la période", "Début de la période", "Fin de la période", "Autre", ""]}>
            {terms && terms.map(term => (
                <BehaviorTermsRow
                    key={term.id}
                    id={term.id}
                    name={term.name}
                    startTime={term.start_time}
                    endTime={term.end_time}
                    onUpdate={onUpdate}
                    onTerminate={onTerminate}
                    onDelete={onDelete}
                />
            ))}
            {currentTermId===undefined && (
                <BehaviorTermsNewRow onStart={onStart} />
            )}
        </Table>
    )
}

function BehaviorTermsRow({ id, name, startTime, endTime, onUpdate, onTerminate, onDelete }) {

    const app = useApp();

    const [change, setChange] = useState(false);
    const [name0, setName0] = useState(name);
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();

    useEffect(() => {
        const date = new Date(startTime);
        setStartDate(date.toLocaleString());
    }, [startTime]);

    useEffect(() => {
        if(endTime === null)
            return;

        const date = new Date(endTime);
        setEndDate(date.toLocaleString());
    }, [endTime]);

    const onTerminate0 = () => {
        if(window.confirm("Vous êtes sur le point de terminer la période: " + name + ". Souhaitez-vous continuer ?")) {
            onTerminate(id);
        }
    };

    const onDelete0 = () => {
        if(window.confirm("Vous êtes sur le point de supprimer la période: " + name + ". Souhaitez-vous continuer ?")) {
            onDelete(id);
        }
    };

    const onUpdate0 = () => {
        if(app.emptyCheck(name0)) {
            return alert("Le nom de la période est vide");
        }

        onUpdate(id, name0);
        setChange(false)
    };

    const onClickRecap = () => {
        app.navigate("/behavior-term-animation/" + id + "/groups");
    };

    return (
        <tr>
            <InputCell
                value={name0}
                onChange={e => {setName0(e.target.value); setChange(true);}}
                type="text"
                placeholder="Nom de la période"
            />
            <td>{startDate}</td>
            <td>
                {endDate ? (
                    endDate
                ) : (
                    "Période en cours"
                )}
            </td>
            <td>
                {endDate && (
                    <button onClick={onClickRecap} >Récapitulatif</button>
                )}
            </td>
            {endDate || change ? (
                <EditDeleteCell change={change} onEdit={onUpdate0} onDelete={onDelete0} />
            ) : (
                <td>
                    <button className="button-edit" onClick={onTerminate0} >Terminer la période</button>
                </td>
            )}
        </tr>
    )
}

function BehaviorTermsNewRow({ onStart }) {

    const [newName, setNewName] = useState("");

    const onStart0 = () => {
        onStart(newName);
    }

    return (
        <NewRowTemplate>
            <InputCell
                value={newName}
                onChange={e => setNewName(e.target.value)}
                type="text"
                placeholder="Nom de la période"
            />
            <td></td>
            <td></td>
            <td></td>
            <AddButtonCell text="Démarrer" onAdd={onStart0} />
        </NewRowTemplate>
    )
}

function BehaviorTerms() {

    const app = useApp();

    const [terms, setTerms] = useState([]);
    const [currentTermId, setCurrentTermId] = useState();

    useEffect(() => {
        app.sendGet("/behavior/terms", data => {
            setTerms(data);
        });
    }, []);

    useEffect(() => {
        const term = terms.find(term => term.end_time===null);

        if(term === undefined)
            setCurrentTermId(undefined);
        else
            setCurrentTermId(term.id);
    }, [terms]);

    const onDeleteTerm = (id) => {
        app.sendPost("/behavior/term/delete", {id: id}, data => {
            if(data.success === false) 
                return alert("Une erreur s'est produite [1]");

            setTerms(terms.filter(val => val.id!==id));
        })
    };

    const onUpdateTerm = (id, newName) => {
        app.sendPost("/behavior/term/update", {id: id, name: newName}, data => {
            if(data.success === false)
                return alert("Une erreur s'est produite [0]");

            setTerms(terms.map(val => val.id===id?({...val, name: newName}):val));
        })
    };

    const onTerminateTerm = (id) => {
        app.sendGet("/behavior/term/stop", data => {
            if(data.success === false) 
                return alert("Une erreur s'est produite [2]");

            setTerms(terms.map(val => val.id===id?(data):val));            
        })
    };

    const onStartTerm = (name) => {
        if(app.emptyCheck(name)) {
            return alert("Le nom de la période est vide");
        }

        app.sendPost("/behavior/term/start", {name: name}, data => {
            if(data.success === false) 
                return alert("Une erreur s'est produite [3]");

            setTerms([...terms, data]);
        })
    };

    return (
        <div>
            <h2>Périodes</h2>
            <BehaviorTermsTable terms={terms} currentTermId={currentTermId} onUpdate={onUpdateTerm} onTerminate={onTerminateTerm} onDelete={onDeleteTerm} onStart={onStartTerm} />
        </div>
    )

}

export default BehaviorTerms;